<template>
    <b-form-group :label="label"
                  :invalid-feedback="errorTxt"
                  :state="state">
        <div class='input-group mb-1' v-if="!disable">
            <input type="text" class="form-control" v-model="newItem" :placeholder="$t('newItem')" v-on:keyup="newItemEnter"/>
            <div class='input-group-append'>
                <button type="button" class="btn btn-sm btn-info" @click="addNewItem">{{$t('create')}}</button>
            </div>
        </div>
        <div class="bs-component">
            <ul class="list-group">
                <draggable v-model="inputVal" :state="state" :readonly="readonly">
                    <li class="list-group-item" v-for="(item, index) in inputVal" :key="'op'+index" style="cursor: move">
                        <font-awesome-icon icon="angle-right"/>
                        {{item}}
                        <div class="pull-right" v-if="!disable">
                            <button type="button" class="btn btn-sm btn-info mr-1">
                                <font-awesome-icon icon="arrows-alt-v"/>
                            </button>
                            <button @click="removeItem(index)" type="button" class="btn btn-sm btn-danger mr-1">
                                <font-awesome-icon icon="trash"/>
                            </button>
                        </div>
                    </li>
                </draggable>
            </ul>
        </div>
    </b-form-group>
</template>

<script>
    import draggable from 'vuedraggable'

    export default {
        components: {draggable},
        props: ['model', 'attribute', 'label', 'type', 'placeholder', 'errors', 'readonly', 'errorOnly', 'disable'],
        data() {
            return {
                inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
                state: null,
                errorTxt: '',
                newItem: null,
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute];
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                            return;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
        methods: {
            addNewItem: function () {
                if (this.model[this.attribute] == null) {
                    this.model[this.attribute] = [];
                }
                if (this.newItem) {
                    this.model[this.attribute].push(this.newItem);
                    this.newItem = null;
                }
            },
            newItemEnter: function (e) {
                if (e.keyCode === 13) {
                    this.addNewItem();
                }
            },
            removeItem: function (index) {
                if (this.model[this.attribute] && this.model[this.attribute].length) {
                    this.model[this.attribute].splice(index, 1);
                }
            }
        },
        i18n: {
            messages: {
                en: {
                    newItem: 'Input to add new',
                },
                vi: {
                    newItem: 'Nhập giá trị để thêm mới',
                }
            }
        }
    }
</script>